export var CategoryFilterMode;
(function (CategoryFilterMode) {
    CategoryFilterMode[CategoryFilterMode["ALL"] = 0] = "ALL";
    CategoryFilterMode[CategoryFilterMode["INCLUDE"] = 1] = "INCLUDE";
    CategoryFilterMode[CategoryFilterMode["EXCLUDE"] = 2] = "EXCLUDE";
})(CategoryFilterMode || (CategoryFilterMode = {}));
export var LabelFilterMode;
(function (LabelFilterMode) {
    LabelFilterMode[LabelFilterMode["ALL"] = 0] = "ALL";
    LabelFilterMode[LabelFilterMode["SOME"] = 1] = "SOME";
})(LabelFilterMode || (LabelFilterMode = {}));
export var ArticleTypeFilterMode;
(function (ArticleTypeFilterMode) {
    ArticleTypeFilterMode[ArticleTypeFilterMode["ALL"] = 0] = "ALL";
    ArticleTypeFilterMode[ArticleTypeFilterMode["SOME"] = 1] = "SOME";
})(ArticleTypeFilterMode || (ArticleTypeFilterMode = {}));
//# sourceMappingURL=content-visibility-settings.i.js.map